<template>
	<transition>
		<div class="failAlert" :style="{ left: left }">
			<span class="success-icon"
				><img src="/images/common/fail-icon.png"
			/></span>
			<span class="alert-text">
				<slot name="alerttext"> </slot>
			</span>
			<span
				@click="closeBanner"
				class="icon-close"
				:style="{ marginRight: marginright }"
				><img src="/images/common/icon-close-white.png"
			/></span>
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		left: {
			default: '0',
			type: String,
		},
		marginright: {
			default: '0',
			type: String,
		},
	},
	emits: ['close'],
	methods: {
		closeBanner() {
			this.$emit('close')
		},
	},
}
</script>
